import { Box, Button, Text, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const CardContainer = styled(Box)`
  position: relative;
  overflow: hidden;
`

export const CardContentContainer = styled(Box)`
  z-index: 1;
`

export const ImageBackground = styled.img`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.12;
`

export const EditButton = styled(Button).attrs({
  variant: 'text',
})`
  text-decoration: underline;
  text-transform: uppercase;
  padding: 0;
  font-size: ${({ theme }) => theme.typography.body_size.small};
  color: ${({ theme }) => getThemeColor('secondary', theme)};
`

export const DescriptionText = styled(Text)`
  p {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* number of lines to show */
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }
`

export const StatusContainer = styled.div<{ completed?: boolean }>`
  ${({ theme, completed }) => {
    const color = completed ? 'success' : 'warning'

    return `
      border: 1px solid ${getThemeColor(color, theme)};
      color: ${getThemeColor(color, theme)};
      background-color: ${getThemeColor(color, theme)}22;
    `
  }}

  font-size: 10px;
  font-weight: 500;
  padding: 6px 8px;
  border-radius: 12px;
`
